export const projectStatusEnum = ((value)=>{
    switch(value){
        default:
        case 0:
            return {value,color:'#E5E7EB', twcolor:'bg-grey-200', status:'New', shortStatus:'N'}
        case 1:
            return {value,color:'#BFDBFE', twcolor:'bg-blue-200', status:'InProgress', shortStatus:'IP'}
        case 2:
            return {value,color:'#FEF08A', twcolor:'bg-yellow-200', status:'Paused', shortStatus:'P'}
        case 3:
            return {value,color:'#BBF7D0', twcolor:'bg-green-200', status:'Finished', shortStatus:'F'}
        case 4:
            return {value,color:'#FECACA', twcolor:'bg-red-200', status:'Cancelled', shortStatus:'C'}
    }
})
export const isProjectFinished = (project) => {return project.status === 3}
export const isProjectCancelled = (project) => {return project.status === 4}

export const taskStatusEnum = ((value)=>{
    switch(value){
        default:
        case 0:
            return {value,color:'#E5E7EB', twcolor:'bg-grey-200', status:'New', shortStatus:'N'}
        case 1:
            return {value,color:'#BFDBFE', twcolor:'bg-blue-200', status:'InProgress', shortStatus:'IP'}
        case 2:
            return {value,color:'#BBF7D0', twcolor:'bg-green-200', status:'Finished', shortStatus:'F'}
        case 3:
            return {value,color:'#FECACA', twcolor:'bg-red-200', status:'Cancelled', shortStatus:'C'}
    }
})
export const isTaskFinished = (task) => {return task.status === 2}
export const isTaskCancelled = (task) => {return task.status === 3}


export const subtaskStatusEnum = ((value)=>{
    switch(value){
        default:
        case 0:
            return {value,color:'#E5E7EB', twcolor:'bg-grey-200', status:'New', shortStatus:'N'}
        case 1:
            return {value,color:'#BFDBFE', twcolor:'bg-blue-200', status:'InProgress', shortStatus:'IP'}
        case 2:
            return {value,color:'#BBF7D0', twcolor:'bg-green-200', status:'Finished', shortStatus:'F'}
        case 3:
            return {value,color:'#FECACA', twcolor:'bg-red-200', status:'Cancelled', shortStatus:'C'}
    }
})

export const deadlineStatus = ((isAfter)=>{
    if(isAfter){
        return '#BBF7D0'
    }else{
        return '#FECACA'
    }
})

export const taskSizesEnum = ((value)=>{
    switch(value){
        default:
        case 1:
            return {value,size:'XS'}
        case 2:
            return {value,size:'S'}
        case 4:
            return {value,size:'M'}
        case 5:
            return {value,size:'L'}
        case 6:
            return {value,size:'XL'}
    }
})

export const taskSizesStringToEnum = ((size)=>{
    switch(size.toUpperCase()){
        default:
        case 'XS':
            return {value:1,size}
        case 'S':
            return {value:2,size}
        case 'M':
            return {value:4,size}
        case 'L':
            return {value:5,size}
        case 'XL':
            return {value:6,size}
    }
})

export const taskSizes = (()=>{
    return [taskSizesEnum(1),taskSizesEnum(2),taskSizesEnum(4),taskSizesEnum(5),taskSizesEnum(6)]
})

export const toolbarActions = {
    AddTask:'AddTask',
    AddBulkTask:'AddBulkTask',
    AddProject:'AddProject',
    AddSubtask:'AddSubtask',
    AddBulkSubtask:'AddBulkSubtask',
    AddResource:'AddResource',
    AddWorklog:'AddWorklog',
    Edit:'Edit',
    Start:'Start',
    Pause:'Pause',
    Finish:'Finish',
    Cancel:'Cancel',
    Delete:'Delete',
}